"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitTx = void 0;
var delay = function (ms) { return new Promise(function (resolve) { return setTimeout(resolve, ms); }); };
var waitTx = function (_a) {
    var txId = _a.txId, nodeApi = _a.nodeApi, _b = _a.timeout, timeout = _b === void 0 ? 1000 * 60 : _b, _c = _a._fetch, _fetch = _c === void 0 ? fetch : _c;
    var rejected = 'rejected';
    var rejectedPromise = function () { return delay(5000).then(function (_) { return rejected; }); };
    var url = "".concat(nodeApi, "/transactions/info/").concat(txId);
    var request = function () {
        return _fetch(url)
            .then(function (x) { return x.ok ? x.json() : rejectedPromise(); })
            .catch(function (_) { return rejectedPromise(); });
    };
    var run = function () { return request().then(function (x) { return x === 'rejected' ? run() : x; }); };
    return Promise.race([run(), delay(timeout).then(function () { return 'timeout'; })]).then(function (x) { return typeof x === 'string' ? 'timeout' : 'done'; });
};
exports.waitTx = waitTx;
//# sourceMappingURL=waitTx.js.map